/* TenantBrandStrip — slim post-login personalization band rendered at
   the TOP of the UniBuy™ top bar (full-width, sits ABOVE the catalog
   header). Designed to feel like an Infosys-issued co-brand strip:
   - Left side: "Curated experience for [Brand]" eyebrow
   - Center/right: the customer's logo or wordmark (small, tasteful)
   - Right edge: optional tagline + dismiss-on-click? No — persistent.

   Sits behind the UniBuy™ chrome stylistically — slate background,
   Infosys-blue eyebrow, small brand asset at ~22px height. Never
   competes with the main Infosys logo in the header below.
*/
import React from "react";
import { Sparkles } from "lucide-react";

export default function TenantBrandStrip({ brand }) {
  if (!brand) return null;
  return (
    <div
      data-testid="tenant-brand-strip"
      className="w-full border-b"
      style={{
        background: `linear-gradient(90deg, rgba(15,23,42,0.96) 0%, rgba(15,23,42,0.92) 60%, ${brand.accent_soft} 100%)`,
        borderColor: brand.accent_border,
      }}
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-2 flex items-center gap-4">
        <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.22em] font-bold text-white/80 shrink-0">
          <Sparkles size={11} className="text-[#7DD3FC]" />
          Curated for
        </div>

        {brand.logo_kind === "image" ? (
          <img
            src={brand.logo_url}
            alt={brand.name}
            data-testid="tenant-brand-strip-logo"
            className="h-7 md:h-8 w-auto object-contain shrink-0"
            style={{ filter: "drop-shadow(0 1px 0 rgba(0,0,0,0.10))" }}
          />
        ) : (
          // Photo asset → use text wordmark in the strip (photo renders
          // badly at 24px); the welcome card in the sidebar uses the
          // photo properly.
          <div
            className="inline-flex items-baseline gap-2 shrink-0"
            data-testid="tenant-brand-strip-wordmark"
          >
            <span
              className="font-display text-[15px] font-bold tracking-tight text-white"
              style={{ letterSpacing: "-0.01em" }}
            >
              {brand.name}
            </span>
          </div>
        )}

        <div className="flex-1 min-w-0" />

        <span className="hidden md:inline text-[11px] text-white/55 truncate italic">
          {brand.tagline}
        </span>
        <span
          className="text-[9px] uppercase tracking-[0.22em] font-bold shrink-0 px-2 py-0.5 rounded-full"
          style={{
            color: "#fff",
            background: brand.accent,
          }}
        >
          × Infosys BPM
        </span>
      </div>
    </div>
  );
}
